<template>
  <div>
    <TableTotalRecords :totalRecords="totalRecords"/>
    <table class="table table-responsive-xs">
      <thead>
      <tr>
        <th><span class="title-header">Gerado</span></th>
        <th class="text-center"><span class="title-header">Tipo</span></th>
        <th class="text-center"><span class="title-header">Usuário</span></th>
        <th class="text-center"><span class="title-header">Origem</span></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <MovimentItem
          v-for="item in moviments"
          :key="item.id"
          :moviment="item"
          @print="$emit('print', $event)"
          @attachment="$emit('attachment', $event)"
          @open-items="$emit('open-items', $event)"
          @delete="$emit('delete', $event)"
      />
      <tr v-show="totalRecords === 0">
        <td colspan="5">
          <span class="title">Nenhum registro encontrado!</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import TableTotalRecords from "@nixweb/nixloc-ui/src/component/shared/TableTotalRecords.vue";
import MovimentItem from "./MovimentItem.vue";

export default {
  name: "MovimentList",
  components: {TableTotalRecords, MovimentItem},
  props: {
    moviments: {type: Array, default: () => []},
    totalRecords: {type: Number, default: 0},
  },
};
</script>

<style scoped>
.table th,
.table td {
  padding: 7px 10px 5px 10px !important;
  border-bottom: 1px solid #e9ecef !important;
}

.title-header {
  font-size: 14px;
  color: #757d8c;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
